import turfObj from "@turf/length";

export default function length(line, options) {
    return turfObj(line, options);
};
